import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";

import HomePage from "@/pages/HomePage";
import ProgramsPage from "@/pages/ProgramsPage";
import ProgramDetailPage from "@/pages/ProgramDetailPage";
import ReviewsPage from "@/pages/ReviewsPage";
import TrainingsPage from "@/pages/TrainingsPage";
import ContactPage from "@/pages/ContactPage";
import LegalPage from "@/pages/LegalPage";
import OrderSuccessPage from "@/pages/OrderSuccessPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";

function PublicLayout({ children }) {
    return (
        <div className="min-h-screen bg-background text-foreground flex flex-col">
            <Navbar />
            <main className="flex-1 pt-20">{children}</main>
            <Footer />
        </div>
    );
}

export default function App() {
    return (
        <div className="App dark">
            <LangProvider>
                <AuthProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
                            <Route path="/programs" element={<PublicLayout><ProgramsPage /></PublicLayout>} />
                            <Route path="/programs/:id" element={<PublicLayout><ProgramDetailPage /></PublicLayout>} />
                            <Route path="/reviews" element={<PublicLayout><ReviewsPage /></PublicLayout>} />
                            <Route path="/trainings" element={<PublicLayout><TrainingsPage /></PublicLayout>} />
                            <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
                            <Route path="/impressum" element={<PublicLayout><LegalPage page="impressum" /></PublicLayout>} />
                            <Route path="/datenschutz" element={<PublicLayout><LegalPage page="datenschutz" /></PublicLayout>} />
                            <Route path="/cookies" element={<PublicLayout><LegalPage page="cookies" /></PublicLayout>} />
                            <Route path="/order/success" element={<PublicLayout><OrderSuccessPage /></PublicLayout>} />
                            <Route path="/admin/login" element={<AdminLoginPage />} />
                            <Route path="/admin" element={
                                <ProtectedRoute><AdminDashboardPage /></ProtectedRoute>
                            } />
                        </Routes>
                    </BrowserRouter>
                    <Toaster theme="dark" position="top-right" richColors />
                </AuthProvider>
            </LangProvider>
        </div>
    );
}
